export default {
  list: { data: [], error: null, loading: false },
  single: { data: [], error: null, loading: false }
}
